import { Component, inject } from '@angular/core';
import { BrandService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  BrandCreateDto,
  BrandDto,
  BrandExcelDownloadDto,
  BrandUpdateDto,
} from '../proxy/general/dtos/brand';
import { BRAND_CONFIG, BRAND_FIELDS } from './brand.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-brand',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, BrandService, ConfirmationService],
  templateUrl: './brand.html',
  styleUrl: './brand.scss',
})
export class Brand extends BaseCrudComponent<
  BrandDto,
  BrandCreateDto,
  BrandUpdateDto,
  BrandExcelDownloadDto
> {
  service = inject(BrandService);
  config = BRAND_CONFIG;
  fields = BRAND_FIELDS;

  protected prepareUpdateDto(data: any, selected: BrandDto): BrandUpdateDto {
    return {
      name: data.name,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'Brand';
  }
}
